import { CloneDataDriveCase } from './domain/useCases/CloneDataCase'
import { cloneDatasourceAdapter } from './external/cloneDatasourceAdapter'
import { cloneRepositoryAdapter } from './infra/cloneRepositoryAdapter'

export const cloneDataInstance = {
  cloneDataDrive: CloneDataDriveCase(
    cloneRepositoryAdapter(cloneDatasourceAdapter)
  )
}
